/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of the condition, one of True, False, Unknown.
 */
export enum ConditionStatus {
  ConditionStatusTrue = 'True',
  ConditionStatusFalse = 'False',
  ConditionStatusUnknown = 'Unknown',
}
